/**
 * Recommended WRF from overstorey inputs — spreadsheet (v13.5).
 */
export function calculateWaf(overstoreyCover, overstoreyHeight, tallUnderstoreyCover) {
  const canopyTerm = 0.488623 -
    0.00334694 * overstoreyCover -
    0.00202058 * overstoreyHeight;
  const understoreyTerm = (-0.001 * tallUnderstoreyCover + 0.33) / 0.33;
  return canopyTerm * understoreyTerm;
}

export function calculateRecommendedWrf(overstoreyCover, overstoreyHeight, tallUnderstoreyCover) {
  const waf = calculateWaf(overstoreyCover, overstoreyHeight, tallUnderstoreyCover);
  if (!waf || waf <= 0) {
    return undefined;
  }
  return 1 / waf;
}



// WEBPACK FOOTER //
// ./src/utils/behaviour_models/vesta_mk2/wrf.js